var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastFinalizedBlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#61D290"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8551 29.0445L42.8866 21.5239L29.8551 14L16.8232 21.5239L29.8551 29.0445Z",
    fill: "#002A12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9229 30.6592L15.8911 23.1387V38.1861L28.9229 45.7099V30.6592Z",
    fill: "#002A12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7874 30.6592V45.7099L43.8188 38.1861V23.1387L30.7874 30.6592Z",
    fill: "#002A12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastFinalizedBlockIcon);
export default __webpack_public_path__ + "static/media/last_finalized_block_icon.27a41c6e1e2c0b81c45485db1fdff56e.svg";
export { ForwardRef as ReactComponent };